var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandIxellCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276.55 214.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:#fff;}.cls-2{fill:#831f82;}.cls-3{fill:#1d1d1b;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m120.51,61.64c2.22-2.93,5.75-4.78,9.69-4.78s7.36,1.86,9.88,4.78h-19.58Zm9.76-28.13c-19.71,           0-35.7,15.98-35.7,35.7s15.98,35.69,35.7,35.69c11.22,0,21.24-5.17,27.78-13.27l-19.38-13.72c-2.21,           2.14-5.21,3.46-8.52,3.46-4.37,0-8.22-2.01-10.37-5.47h45.52c.44-2.27.68-4.31.68-6.69,           0-19.72-15.99-35.7-35.71-35.7m-27.07,3.06h-29.98l-7.08,10.79-6.36-10.79h-29.62l21.83,33.1-21.95,           30.95h28.91l7.2-10.07,7.08,10.08h29.74l-22.42-30.96,22.67-33.1Zm66.45,64.12h23.03V0h-23.03v100.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.41,
    y: 36.46,
    width: 22.55,
    height: 64.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m14.92,3.31C6.68,3.31,0,9.99,0,18.23s6.68,14.93,14.92,14.93,14.93-6.69,14.93-14.93S23.17,           3.31,14.92,3.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 196.53,
    y: 0.02,
    width: 23.03,
    height: 100.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m32.62,132.54c-18.02,0-32.62,14.61-32.62,32.62s14.61,32.62,32.62,32.62h168.86v-65.24H32.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.79,153.51h5.91c1.75,0,3.06.43,3.93,1.28.87.85,1.31,2.03,1.31,3.51,0,1.56-.44,2.77-1.31,           3.63-.87.85-2.19,1.28-3.93,1.28h-5.91v-9.7Zm21.19,31.23l-9.03-15.5c2.86-.85,5.03-2.3,6.5-4.35,           1.47-2.04,2.2-4.37,2.2-6.97,           0-2.3-.54-4.4-1.62-6.27-1.08-1.88-2.7-3.35-4.88-4.43-2.18-1.08-4.81-1.62-7.89-1.62h-16.01v39.15h9.54v-14.78h2.29l8.14,           14.78h10.76Zm-115.94-19.63c0,3.87.84,7.3,2.51,10.32,1.67,3.01,4,5.36,7,7.05,2.99,1.69,6.39,           2.54,10.18,2.54,4.65,0,8.62-1.22,11.93-3.65,3.31-2.43,5.52-5.77,6.64-10.01h-10.48c-.78,           1.64-1.89,2.88-3.32,3.74s-3.06,1.28-4.88,1.28c-2.94,           0-5.32-1.02-7.14-3.07-1.82-2.04-2.73-4.78-2.73-8.2s.91-6.15,2.73-8.2c1.82-2.04,4.2-3.07,           7.14-3.07,1.82,0,3.45.43,4.88,1.28,1.43.86,2.54,2.1,3.32,           3.74h10.48c-1.12-4.24-3.33-7.58-6.64-10.04-3.31-2.45-7.29-3.68-11.93-3.68-3.79,0-7.19.85-10.18,           2.54-2.99,1.69-5.33,4.05-7,7.08-1.67,3.03-2.51,6.48-2.51,10.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "158.6 153.23 158.6 145.59 134.62 145.59 134.62 184.74 158.6 184.74 158.6 177.1 144.15              177.1 144.15 168.51 156.92 168.51 156.92 161.15 144.15 161.15 144.15 153.23 158.6 153.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.43,170.47l4.8-14.33,4.85,14.33h-9.65Zm14.44,14.28h10.09l-14.17-39.15h-11.04l-14.16,           39.15h9.98l2.34-6.92h14.61l2.34,6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m178.34,165.17c0-26.84,21.76-48.61,48.61-48.61s48.61,21.76,48.61,48.61-21.76,48.61-48.61,           48.61-48.61-21.76-48.61-48.61"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 226.94,
    cy: 165.17,
    r: 48.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.67,165.17c0-22.24,18.03-40.27,40.27-40.27s40.27,18.03,40.27,40.27-18.03,40.27-40.27,           40.27-40.27-18.03-40.27-40.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "213.05 145.26 207.09 142.69 204.52 136.73 201.95 142.69 195.99 145.26 201.95 147.83               204.52 153.79 207.09 147.83 213.05 145.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "262.59 156.1 257.31 153.82 255.04 148.55 252.76 153.82 247.49 156.1 252.76 158.37              255.04 163.65 257.31 158.37 262.59 156.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m244.75,162.2l-17.77-27.76-17.77,27.76c-5.3,8.28-4.1,19.34,2.85,26.29,3.98,3.98,9.28,6.18,           14.92,6.18s10.93-2.19,14.92-6.18c6.95-6.96,8.15-18.01,2.85-26.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m226.98,187.8c-2.08,0-4.05-.46-5.83-1.26,10.07-.7,18.1-8.73,18.8-18.8.8,1.78,1.26,3.75,           1.26,5.83,0,7.86-6.37,14.23-14.23,14.23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIxellCare);
export default __webpack_public_path__ + "static/media/brand_ixellCare.48e04bb5bed73ff6a6e0dd8a111933d6.svg";
export { ForwardRef as ReactComponent };